{
  "post-office.confluence-create-agent-spotlight.spotlight-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "post-office.confluence-create-agent-spotlight.spotlight-description": [
    {
      "type": 0,
      "value": "Create custom agents trained on your team's workflow so they can jump in at anytime."
    }
  ],
  "post-office.confluence-create-agent-spotlight.spotlight-header": [
    {
      "type": 0,
      "value": "Build your perfect teammate"
    }
  ],
  "post-office.confluence-create-agent-spotlight.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Create agent illustration"
    }
  ]
}